"use client";

import { LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useFormStatus } from "react-dom";
import { cn } from "@/lib/cn";

/**
 * Destructive submit that needs a second click within a few seconds
 * (avoids browser confirm() dialogs).
 */
export function ConfirmButton({ children, confirmText = "Click again to confirm", className }: { children: React.ReactNode; confirmText?: string; className?: string }) {
  const [armed, setArmed] = useState(false);
  const { pending } = useFormStatus();
  useEffect(() => {
    if (!armed) return;
    const t = window.setTimeout(() => setArmed(false), 4000);
    return () => window.clearTimeout(t);
  }, [armed]);

  return (
    <button
      type={armed ? "submit" : "button"}
      onClick={() => !armed && setArmed(true)}
      disabled={pending}
      className={cn(
        "inline-flex h-10 items-center gap-2 rounded-full px-4 text-[14px] font-medium transition-colors disabled:opacity-60",
        armed ? "bg-red-500 text-white hover:bg-red-500/90" : "border border-red-400/30 text-red-300 hover:bg-red-500/10",
        className,
      )}
    >
      {pending && <LoaderCircle size={16} className="animate-spin" />}
      {armed ? confirmText : children}
    </button>
  );
}
